import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import { Excel } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'
import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

var queryParam = {
  timeRange: 'today',
  date: [getBeforeDate('today'), new Date().toISOString().slice(0, 10)]
}
const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', formData.value)
}

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/groupUsers/queryExportData', queryInfo)
}

const handleGroupUsers = (item: any) => {
  getExportData().then((res) => {
    let customHeader = [
      '群ID',
      '群名称',
      '主体ID',
      '主体名称',
      '上周期客户数',
      '本周期客户数',
      '退群数',
      '成交移群数'
    ]
    let header = [
      'gid',
      'gname',
      'corpId',
      'corpName',
      'userCountPre',
      'userCountNow',
      'quitUserNum',
      'contractUserNum'
    ]
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '退群统计-' + filename,
      title: '退群统计-' + filename,
      data: reactive(res),
      header,
      customHeader
    })
  })
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "groupUsers",
      onDownBtnClick: handleGroupUsers,
      onSortChange: handleSortChange
    }, {
      quitUserNum: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({
            color: scope.row.quitUserNum > 0 ? '#d71b1b' : '#10910c'
          })
        }, _toDisplayString(scope.row.quitUserNum), 5)
      ]),
      contractUserNum: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({
            color: scope.row.contractUserNum > 0 ? '#d71b1b' : '#10910c'
          })
        }, _toDisplayString(scope.row.contractUserNum), 5)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})